<template>
  <!--<div class="tab-pane active">-->
  <!--<router-view></router-view>-->
  <!--</div>-->
  <b-card no-body align="left" class="mt-3">
    <b-card-header><h1>Projects</h1></b-card-header>
    <b-card-body>
      <b-row v-if="folderTree !== null">
        <b-col sm="3">
          <!--Available Folders-->
          <ul id="folder-tree">
            <recursive-folder :item="folderTree"
                              :active-folder-id="activeFolder.id"
                              @folder-selected="activateFolder"
                              @change-folder="activateFolderAfterDelete($event)"
            />
          </ul>
          <!--End Available Folders-->
          <!--New Folder Tools-->
          <b-button v-b-modal="'folderAdd'" variant="secondary" @click="newFolderName=''">
            Add Folder
          </b-button>
          <b-modal id="folderAdd" ref="folderAddModal" @ok="createNewFolder">
            <h4>Enter new folder name</h4>
            <b-input
              v-model="newFolderName"
              placeholder="New Folder Name"
              class="mb-3"
            />
          </b-modal>
          <!--End new Folder Tools-->
        </b-col>

        <b-col sm="9">
          <b-table ref="projectTable"
                   :items="projectsInActiveFolder"
                   :fields="projectTableFields"
          >
            <template slot="createdOn" slot-scope="data">
              {{ dateDisplay(data.item.createdOn.date) }}
            </template>

            <template slot="lastModified" slot-scope="data">
              {{ dateDisplay(data.item.lastModified.date) }}
            </template>

            <template slot="actions" slot-scope="data">
              <b-link :to="'/edit/' + data.item.id + '/1'"
                      @click="getFullProject(data.item.id)"
              >
                <font-awesome-icon :id="data.item.id + '-edit-pop'"
                                   :icon="['far','edit']"
                                   :size="iconSize"
                                   class="mr-1 projectAction"
                />
                <b-popover content="Edit project"
                           :target="data.item.id + '-edit-pop'"
                           triggers="hover"
                />
              </b-link>
              <b-link @click="copyThisProject(data.item.id)">
                <font-awesome-icon :id="data.item.id + '-copy-pop'"
                                   :icon="['far','copy']"
                                   :size="iconSize"
                                   class="mr-1 projectAction"
                />
                <b-popover content="Copy project"
                           :target="data.item.id + '-copy-pop'"
                           triggers="hover"
                />
              </b-link>
              <!--<b-link v-b-modal="'changeFolderModal-' + data.item.id">-->
              <b-link @click="openChangeFolderModal(data.item.id)">
                <font-awesome-icon :id="data.item.id + '-folder-pop'"
                                   :icon="['far','folder-open']"
                                   :size="iconSize"
                                   class="mr-1 projectAction"
                />
                <b-popover content="Move to another folder"
                           :target="data.item.id + '-folder-pop'"
                           triggers="hover"
                />
              </b-link>
              <b-link @click="openShareProjectModal(data.item.id)">
                <font-awesome-icon :id="data.item.id + '-share-pop'"
                                   :icon="['far','share-alt']"
                                   :size="iconSize"
                                   class="mr-1 projectAction"
                />
                <b-popover content="Share"
                           :target="data.item.id + '-share-pop'"
                           triggers="hover"
                />
              </b-link>
              <!--<b-link v-b-modal="'deleteProjectModal-' + data.item.id">-->
              <b-link @click="openDeleteProjectModal(data.item.id)">
                <font-awesome-icon :id="data.item.id + '-trash-pop'"
                                   :icon="['far','trash-alt']"
                                   :size="iconSize"
                                   class="mr-1 projectAction"
                />
                <b-popover content="Delete"
                           :target="data.item.id + '-trash-pop'"
                           triggers="hover"
                />
              </b-link>
              <!--</b-link>-->
              <!--<delete-project-modal :project-to-delete="data.item"-->
              <!--:parentKey="key"-->
              <!--v-on:confirm-delete="key += 1"-->
              <!--:return-focus="$refs['new-project']"-->
              <!--/>-->
            </template>
          </b-table>

          <b-modal id="changeFolderModal"
                   ref="changeFolderModal"
                   title="Change Folder"
                   title-tag="h4"
                   :hide-footer="true"
          >
            Project Name: {{ currentProject !== null ? currentProject.projectName : "Error: No Project Available" }}
            <hr size="10">
            Select Folder:
            <b-form-select v-model="projectNewFolderId"
                           :options="flatFolders"
            />
            <hr size="10">
            <b-button type="button" @click="saveFolderChange( currentProject.id, projectNewFolderId )">
              Save
            </b-button>
          </b-modal>

          <b-modal id="shareProjectModal"
                   ref="share-project"
                   :ok-disabled="true"
                   title="Share project">
            <label>Enter email of recipient</label>
            <b-form-input type="text" v-model="userToShareWith" placeholder="Enter Email"></b-form-input>
            <b-button block class="mt-3" @click="commitShareProject">Share</b-button>
          </b-modal>


          <b-button ref="new-project"
                    class="btn-block"
                    variant="secondary"
                    @click="createNewProject">
            <font-awesome-icon :icon="['far','plus-circle']"/>
            New project in {{ activeFolder.name }}
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
  // import ProjectCreationContainer from "./project/ProjectCreationContainer";

  import store from "./../../store/store.js"
  import {mapState, createNamespacedHelpers} from 'vuex'
  import {mapFields} from 'vuex-map-fields'

  const {mapActions} = createNamespacedHelpers('user');

  import dayjs from 'dayjs'
  import RecursiveFolder from './RecursiveFolder'

  import DeleteProjectModal from './DeleteProjectModal'
  import RxTextEntryBox from "./project/inputComponents/RxTextEntryBox";

  export default {
    name: "Projects",
    // components: {ProjectCreationContainer}
    components: {
      RecursiveFolder,
    },
    data: function () {
      return {
        // folderTree: folderTree,
        userSelectedFolder: null,
        newParentFolder: null,
        newFolderName: null,
        showDeleteProjectModal: false,
        projectTableFields: [
          'projectName',
          'createdOn',
          'lastModified',
          'actions'
        ],
        iconSize: 'lg',
        key: 0,
        projectNewFolderId: null,
        projectToEdit: null,
        store: store
      }
    },
    computed: {
      ...mapState('account', ['user']),
      // ...mapState('rx', ['availableProjects', 'folderTree', 'currentProject']),
      ...mapFields('rx', ['availableProjects', 'folderTree', 'currentProject', 'userToShareWith']),
      projectsInActiveFolder() {
        return this.availableProjects.filter((p) => {
          // activefolder starts out null so we need to check for that
          const k = this.activeFolder ? this.activeFolder.id : 1;
          return (p.folder === k) ||
            (this.activeFolder.id === this.folderTree.id && p.folder === null);
        })
      },
      activeFolder() {
        // This is computed so that we can ensure a valid folder is properly initialized on load
        if (this.userSelectedFolder !== null && this.userSelectedFolder !== undefined) {
          return this.userSelectedFolder
        } else {
          return this.folderTree
        }
      },
      flatFolders() {
        /*
        Create a flat list of available folders to be used when moving a project to a folder.
         */
        const folders = [];
        const visited = [];

        const dfs_folder = function (folder, prefix = "") {
          visited.push(folder.id);
          console.log("Visited", folder.id, folder.name);

          folders.push({value: folder.id, text: prefix + folder.name});

          if (folder.children.length > 0) {
            folder.children.map(c => {
              if (!visited.includes(c.id)) {
                dfs_folder(c, prefix + '-')
              }
            })
          }
        };
        dfs_folder(this.folderTree, "");
        return folders
      }
    },
    methods: {
      ...mapActions('rx', [
        'copyProject',
        'saveProject',
        'shareProject',
        'deleteProject'
      ]),
      dateDisplay(isoDate) {
        // Convert ISO UTC datetime to local timezone and generate display text
        return dayjs(isoDate)
          .add(new Date().getTimezoneOffset(), 'minute')
          .format('MMMM D, YYYY');
      },
      activateFolder(folder) {
        // Method used by RecursiveFolder to set active folder
        this.userSelectedFolder = folder;
      },
      activateFolderAfterDelete(folderId) {
        console.log("Folder delete event:", folderId);

        // DFS for the chosen folder
        const visited = [];
        const dfs_folder = function (folder) {
          visited.push(folder.id);
          if (folder.children.length > 0) {
            if (folder.id === folderId) {
              return folder
            }
            folder.children.map(c => {
              if (!visited.includes(c.id)) {
                dfs_folder(c)
              }
            })
          }
        };

        this.userSelectedFolder = dfs_folder(this.folderTree);
      },
      createNewFolder() {
        store.dispatch('rx/saveFolder', {
          parentId: this.activeFolder.id,
          folderName: this.newFolderName
        }).then(() => {
          this.getFolders()
        });
      },
      getFolders() {
        return store.dispatch('rx/getFolders')
      },
      createNewProject() {
        store.dispatch('rx/createNewProject', {folderId: this.activeFolder.id}).then(() =>
          store.dispatch('rx/getAvailableProjects')
        )
      },
      getFullProject(id) {
        console.log("Starting project fetch");
        return store.dispatch('rx/getFullProject', id)
      },
      copyThisProject(id) {
        store.dispatch('rx/copyProject', id).then(() => store.dispatch('rx/getAvailableProjects'))
      },
      openDeleteProjectModal(projectId) {
        console.log("Opening deletion modal for project", projectId);
        this.getFullProject(projectId).then(project => {
        this.$bvModal.msgBoxConfirm("Are you sure you want to delete the project " + this.currentProject.projectName + "?")
          .then((value) => {
            if (value === true) {
              store.dispatch('rx/deleteProject', projectId).then(() => store.dispatch('rx/getAvailableProjects'));
            }
          })
        });
      },
      openShareProjectModal(projectId) {
        console.log("Opening share modal for project", projectId);
        this.currentProject = this.getFullProject(projectId);

        this.$refs['share-project'].show()

      },
      commitShareProject(){
        store.dispatch('rx/shareProject').then(result => {
          if (result.status === 'success'){
            this.userToShareWith = null;
            this.$refs['share-project'].hide()
          }
        })
      },
      openChangeFolderModal(projectId) {
        console.log("Changing folder for project ", projectId);
        this.getFullProject(projectId).then(result => {
          console.log('result', result);
          this.$bvModal.show('changeFolderModal')
        });
      },

      saveFolderChange(projectId, folderId) {
        console.log("Saving folder change", projectId, folderId);
        // Load project into Vuex
        this.getFullProject(projectId).then(() => {
          // Set folder
          this.currentProject.folder = folderId;

          // Save
          store.dispatch('rx/saveProject').then(() => {
            store.dispatch('rx/getAvailableProjects')
          })
        });

        this.$bvModal.hide('changeFolderModal')
      },
    },
    beforeMount() {
      // Load all folder info
      console.log("loading folders");
      this.getFolders().then(() => {
        this.activateFolder(this.folderTree);
        store.dispatch('rx/getAvailableProjects')
      });
    }
  };
</script>

<style scoped lang="scss">
  @import './../../scss/custom';

  .projectAction {
    color: $light-blue
  }

</style>
